import React, { FC } from 'react'
import { Icon, TooltipNew } from '@centra/centra-ui'
import { format, parseISO } from 'date-fns'
import { ru } from 'date-fns/locale'

export const ArchivedIcon: FC<{ archivedAt: string; clientKind: string }> = ({ archivedAt, clientKind }) => {
  const toolTipText = `${clientKind} находится в архиве с ${format(parseISO(archivedAt), 'dd.MM.yyyy', {
    locale: ru,
  })}`

  return (
    <TooltipNew content={toolTipText} maxWidth={180}>
      <Icon id={'archivedIcon'} name={'archiveOutline'} view={'basicGreySemiDark'} size={14} />
    </TooltipNew>
  )
}
